











































import PreNegotiationSelectedAccountsTable from '@/views/preNegotiation/installment/PreNegotiationSelectedAccountsTable.vue';
import PreNegotiationInstallmentsTable from '@/views/preNegotiation/installment/PreNegotiationInstallmentsTable.vue';
import PreNegotiationAccountParams from '@/views/preNegotiation/installment/PreNegotiationAccountParams.vue';
import { defineComponent } from '@vue/composition-api';
import AccountsReceivableParamsRepository from '@/repositories/pre-negotiations/accounts-receivable/AccountsReceivableParamsRepository';
import AccountsReceivableParams from '@/domain/models/preNegotiations/accountsReceivable/AccountsReceivableParams';
import AccountsReceivableListFeeTypeEnum from '../enums/AccountsReceivableListFeeTypeEnum';

export default defineComponent({
  name: 'PreNegotiationInstallments',
  components: {
    PreNegotiationSelectedAccountsTable,
    PreNegotiationInstallmentsTable,
    PreNegotiationAccountParams,
  },
  data() {
    const loading: boolean = false;

    const accountParamsData: AccountsReceivableParams|undefined = undefined;

    const accountsReceivableParamsRepository:
      AccountsReceivableParamsRepository = new AccountsReceivableParamsRepository();

    return {
      loading,
      accountParamsData: accountParamsData as AccountsReceivableParams|undefined,
      accountsReceivableParamsRepository,
    };
  },
  watch: {
    accountParamsData: {
      deep: true,
      handler() {
        this.$store.commit('pre-negotiation/setAccountParams', { ...this.accountParamsData });
      },
    },
  },
  computed: {
    companyGroupId(): number {
      return this.$store.state.authentication.user.company_group_id;
    },
    companyIds(): number[] {
      return this.$store.state.authentication.companyIds;
    },
    hasAccountLoaded(): boolean {
      return this.accountParamsData !== undefined;
    },
  },
  created() {
    this.getAccountParametersByGroup();
  },
  methods: {
    setAccountParamsData(params: AccountsReceivableParams | undefined): void {
      if (!params) {
        this.accountParamsData = {
          carrier: '',
          nature: '',
          prefix: '',
          type: '',
          defaultFeePercentage: 0,
        };

        return;
      }

      if (params.defaultFeePercentage) {
        this.$store.commit('pre-negotiation/setTotalFee', params.defaultFeePercentage);
        this.$store.commit('pre-negotiation/setTotalFeeType', AccountsReceivableListFeeTypeEnum.PERCENTAGE);
      }

      this.accountParamsData = params;
    },
    async getAccountParametersByGroup(): Promise<void> {
      try {
        this.loading = true;

        const params = await this.accountsReceivableParamsRepository.getByCompanyGroupId(
          this.companyGroupId,
          this.companyIds,
        );

        this.setAccountParamsData(params);

        this.$store.commit('pre-negotiation/setAccountParams', { ...params });
      } catch (error) {
        this.$notification.error('Houve um problema ao requisitar os parâmetros de títulos desse grupo');
      } finally {
        this.loading = false;
      }
    },
  },
});
